import styled from 'styled-components';

export const StyledBackdrop = styled.div`
  opacity: ${({ active }) => active};
  width: 100%;
  height: 100%;
  z-index: 100;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  background: ${({ backgroundGradient }) =>
    backgroundGradient ||
    `linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.8) 100%
    ),
    linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, transparent 100%)`};
  align-items: center;
  justify-content: center;
  transition: opacity 0.4s var(--customEase);
`;
